import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { ApiError } from '../../api/client'
import { aiTopUsersTableQuery } from '../../api/settingsDiagnosticActions'
import { DataTable, useTableState, type TableColumn } from '../../ui/DataTable'

/**
 * Easeedesk > AI Analizer Actions > AI Analizer Top Users, element cu element
 * fata de `diagnostic/settings/top_users/index.php` + `AiAnalizerTopUsers()`
 * din `adam_intop_settings.js`: tabelul cu omul si cate comenzi AI a rulat
 * (`it_cmd_commands_responses`, `command_source = 2`), pe compania furnizorului.
 */
const TABLE_ID = 'ai-top-users-table'
const ORDER_NAMES = ['user_name', 'commands']

function esc(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

function columns(): TableColumn[] {
  return [
    { index: 0, title: 'User', orderable: true, visible: true, className: 'align-left', html: (row) => esc(String(row.user_name ?? '')) },
    { index: 1, title: 'Commands', orderable: true, visible: true, className: 'align-left', html: (row) => String(Number(row.commands ?? 0)) },
  ]
}

export function AiTopUsersPage() {
  const [state, setState] = useTableState(TABLE_ID, { start: 0, length: 25, order: { column: 1, dir: 'desc' }, search: '' })
  const cols = useMemo(() => columns(), [])
  const table = useQuery({
    ...aiTopUsersTableQuery({
      draw: 1,
      start: state.start,
      length: state.length,
      orderColumn: state.order.column,
      orderName: ORDER_NAMES[state.order.column] ?? 'commands',
      orderDir: state.order.dir,
      search: state.search,
    }),
    placeholderData: keepPreviousData,
  })

  if (table.error instanceof ApiError && table.error.status === 403) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-circle" aria-hidden="true"></i> You do not have access to this action.
      </div>
    )
  }

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <h4>AI Analizer Top Users</h4>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-12">
          <DataTable
            id={TABLE_ID}
            columns={cols}
            rows={(table.data?.data ?? []) as Record<string, unknown>[]}
            total={table.data?.recordsFiltered ?? 0}
            fetching={table.isFetching}
            error={table.error ? table.error.message : null}
            onRetry={() => void table.refetch()}
            state={state}
            onState={setState}
            rowId={(row) => String(row.DT_RowId ?? `row_${Number(row.user_id)}`)}
            emptyHint="Nobody has run an AI-suggested command yet."
          />
        </div>
      </div>
    </div>
  )
}
